export const EMPLOYEE_PAGE_SIZE = 10;
export const EMPLOYEE_PAGE_SIZE_OPTIONS = ['10', '20', '30'];

export const TABLE_FILTER_OPTIONS = [
  { label: 'Complete', value: true },
  { label: 'All', value: 'all' },
  { label: 'Incomplete', value: false },
];

export const MANAGER_TYPE = {
  REPORTING_MANAGER: 'reporting-manager',
  HRBP: 'hrbp',
};

export const ERROR_MESSAGES = {
  SELECT_HRBP: 'Please select HRBP.',
  SELECT_REPORTING_MANAGER: 'Please select reporting manager.',
  SELECT_AT_LEAST_ONE_ROLE: 'Please select at least one role position.',
  SELECT_PROFILE_ASSIGNMENT: 'Please select a profile assignment.',
  FETCH_EMPLOYEES_FAILED: 'Employee data could not be loaded.',
  LOAD_EMPLOYEE_DATA_FAILED: 'Employee data could not be loaded.',
  UPDATE_EMPLOYEE_FAILED: 'Unable to update employee. Please try again.',
};

export const WARNING_TITLES = {
  FETCH_EMPLOYEES: 'Employee Data Unavailable',
  LOAD_EMPLOYEE_DATA: 'Employee Data Unavailable',
};

export const ERROR_TITLES = {
  UPDATE_EMPLOYEE: 'Unable to Update Employee',
};

export const getApiErrorMessage = (error, fallbackMessage) => {
  return fallbackMessage;
};
